import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { IPrSFilter } from 'src/@types/SearchFilterTypes';
import { RHFSelect, RHFTextField } from 'src/components/hook-form';
import FormProvider from 'src/components/hook-form/FormProvider';
import { FormItem, SearchFormLayout } from 'src/layouts/form/FormLayout';
import { useStores } from 'src/models';
import removeNullUndefined from 'src/utils/removeNullUndefined';

export interface ISearchFormProps {
  onSearch: (data: IPrSFilter) => void;
}

export const SearchForm = observer(({ onSearch }: ISearchFormProps) => {
  const { t } = useTranslation();
  const methods = useForm<IPrSFilter>({ defaultValues: { prNotiCtgyCd: '', searchText: '' } });
  const { commonCodeStore } = useStores();
  const { noticeSelectOptions } = commonCodeStore;

  // 검색 함수
  const onValid = (data: IPrSFilter) => {
    const cleanedData = removeNullUndefined(data);
    onSearch(cleanedData);
  };

  return (
    <FormProvider methods={methods} onSubmit={methods.handleSubmit(onValid)}>
      <SearchFormLayout method={methods} open={true}>
        <FormItem>
          <RHFSelect
            label={t('notice.fields.category')}
            name="prNotiCtgyCd"
            options={noticeSelectOptions}
          />
        </FormItem>
        <FormItem size={2}>
          <RHFTextField label={t('notice.fields.searchText')} name="searchText" />
        </FormItem>
      </SearchFormLayout>
    </FormProvider>
  );
});

export default SearchForm;
